/**
 * Command Line training dashboard URL (API :3001 when SPA runs on :3000).
 * Override: REACT_APP_LEARNING_DASHBOARD_URL
 * Demo mode retired — never append ?demo=1.
 * @param {{ openDashboard?: boolean }} [options]
 *   openDashboard — force course list (clears sticky lesson restore on :3001).
 */
export function getLearningDashboardUrl(options = {}) {
  const openDashboard = Boolean(options && options.openDashboard);
  const custom =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_LEARNING_DASHBOARD_URL
      ? String(process.env.REACT_APP_LEARNING_DASHBOARD_URL).trim()
      : '';
  let base = '';
  try {
    if (custom) {
      base = custom;
    } else {
      const host = window.location.hostname;
      const proto = window.location.protocol || 'http:';
      const port = String(window.location.port || '');
      if (host === 'localhost' || host === '127.0.0.1') {
        base = `${proto}//${host}:3001/learning/terminal-web/index.html`;
      } else if (port === '3000') {
        base = `${proto}//${host}:3001/learning/terminal-web/index.html`;
      } else {
        base = `${proto}//${host}/learning/terminal-web/index.html`;
      }
    }
  } catch {
    base = 'http://localhost:3001/learning/terminal-web/index.html';
  }
  if (!openDashboard) return base;
  try {
    const u = new URL(base, typeof window !== 'undefined' ? window.location.href : 'http://localhost');
    u.searchParams.set('openDashboard', '1');
    return u.toString();
  } catch {
    return base.includes('?') ? `${base}&openDashboard=1` : `${base}?openDashboard=1`;
  }
}
